import jQuery from 'jquery';

jQuery(($) => {
    function init() {
        if (!document.querySelector('.js-bulk-reg')) return;

        const addBtn = $('.js-add-participant');
        const inputs = document.querySelectorAll('.js-bulk-reg-form input');
        const submitBtn = $('.js-submit');

        submitBtn.click(() => {
            sendForms();
        });

        addBtn.click((event) => {
            event.preventDefault();
            addFieldSet();
        });

        // Validate inputs on the go
        inputs.forEach((input) => {
            input.addEventListener('focusout', checkValid);
        });
    }

    function findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    function sendForm(form) {
        const next_form = form.nextSibling;

        if ($(form).hasClass('finished')) {
            if ($(next_form).hasClass('js-bulk-reg-form')) {
                sendForm(next_form);
            }
            return;
        }

        console.log('Not finished');

        const firstname = form.querySelector('.js-firstname').value;
        const lastname = form.querySelector('.js-lastname').value;
        const email = form.querySelector('.js-email').value;
        const phone = form.querySelector('.js-phone').value;
        const application_wpid = form.querySelector(
            '.js-application-wpid',
        ).value;

        $.ajax({
            type: 'post',
            dataType: 'json',
            url: berghs.ajax_url,
            data: {
                action: 'save_registration',
                security: berghs.ajax_nonce,
                firstname,
                lastname,
                email,
                phone,
                application_wpid,
            },
            success(data) {},
            complete(data) {
                if (data.responseJSON === true) {
                    if ($(next_form).hasClass('js-bulk-reg-form')) {
                        sendForm(next_form);
                    }
                    $(form).addClass('finished');
                    $('.js-response-message').text('');
                } else {
                    // console.log(data);
                    $('.js-response-message').text(data.responseJSON);
                }
                $('.js-loader').fadeOut();
            },
            error(data) {
                $('.js-response-message').text(data.responseJSON);
            },
        });
    }

    function sendForms(e) {
        if (checkEmailDuplicates()) {
            return false;
        }

        if (!validateForm()) {
            return false;
        }

        $('.js-loader').fadeIn();

        const forms = document.getElementsByClassName('js-bulk-reg-form');
        const firstForm = forms[0];
        sendForm(firstForm);
    }

    function validateForm() {
        const inputs = document.querySelectorAll('.js-bulk-reg-form input');

        inputs.forEach((input) => {
            validateInput(input);
        });

        if (document.querySelector('.input-error')) {
            return false;
        }

        return true;
    }

    function checkEmailDuplicates() {
        const inputs = [];
        let flag = false;

        $('.js-bulk-reg-form input.js-email').each(function () {
            if ($.inArray(this.value, inputs) !== -1) flag = true;

            if (this.value !== '') {
                inputs.push(this.value);
            }
        });

        if (flag === true) {
            $('.js-response-message').text(
                'Du får inte använda samma e-postadress för mer än en deltagare!',
            );
            return true;
        }

        $('.js-response-message').text('');
        return false;
    }

    function addFieldSet() {
        const fieldsets = document.querySelectorAll('.js-bulk-reg-form');
        const last = fieldsets[fieldsets.length - 1];
        const clone = last.cloneNode(true);
        $(clone).removeClass('finished');

        const lastId = last.dataset.id;
        const nextId = parseInt(lastId) + 1;

        clone.dataset.id = nextId;

        const cloneInputs = clone.querySelectorAll('.js-participant input');

        cloneInputs.forEach(clearInput);
        clone.classList.remove('removable');

        last.parentNode.insertBefore(clone, last.nextSibling);

        // Make it possible to remove participants if more than one
        countParticipants();
    }

    function countParticipants() {
        const fieldsets = document.querySelectorAll('.js-bulk-reg-form');
        const closeBtns = document.querySelectorAll('.js-close');

        // Make it possible to remove participants if more than one
        if (fieldsets.length > 1) {
            makeRemovable(closeBtns);
        } else {
            notRemovable(closeBtns);
        }
    }

    function makeRemovable(closeBtns) {
        $('.js-bulk-reg-form').hover(
            function () {
                $(this).addClass('removable');
            },
            function () {
                $(this).removeClass('removable');
            },
        );

        closeBtns.forEach((closeBtn) => {
            closeBtn.addEventListener('click', removeFieldset);
        });
    }

    function notRemovable(closeBtns) {
        closeBtns.forEach((closeBtn) => {
            closeBtn.addEventListener('click', removeFieldset);
        });
        $('.js-bulk-reg-form').unbind('mouseenter mouseleave');
    }

    function removeFieldset(e) {
        const fieldset = findAncestor(e.target, 'js-bulk-reg-form');
        fieldset.parentNode.removeChild(fieldset);

        countParticipants();
    }

    function clearInput(el) {
        // Clean inputs of cloned fieldset classes and data

        el.value = '';
        el.classList.remove('valid');
        el.classList.remove('not-empty');
        el.addEventListener('focusout', checkValid);

        if (el.parentNode.querySelector('.input-error')) {
            const errorSpan = el.parentNode.querySelector('.input-error');
            el.parentNode.removeChild(errorSpan);
        }
    }

    function createErrorMsg(type) {
        const span = document.createElement('span');

        let errorText;
        let typeClass;

        if (type == 'phone') {
            errorText = document.createTextNode(
                'Du måste fylla i ett korrekt mobilnummer.',
            );
            typeClass = ' input-error--phone';
        } else if (type == 'email') {
            errorText = document.createTextNode(
                'Du måste fylla i en korrekt e-postadress.',
            );
            typeClass = ' input-error--email';
        } else {
            errorText = document.createTextNode('Du måste fylla i namn.');
            typeClass = ' input-error--text';
        }

        span.appendChild(errorText);
        span.className = 'input-error';
        span.className += typeClass;

        return span;
    }

    function validatePhone(input) {
        // var phone = input.value;
        // var inputWrap = input.parentElement;
        // var pattern = /[0-9 -()+]+$/;
        //
        // if (!pattern.test(phone) || (phone.length > 12 || phone.lengt < 6) || (phone === '')) {
        //   if (inputWrap.querySelector('.input-error--phone')) return;
        //   var span = createErrorMsg('phone');
        //   inputWrap.appendChild(span);
        //   return false;
        // }
        //
        // if (inputWrap.querySelector('.input-error--phone')) {
        //   var errorSpan = inputWrap.querySelector('.input-error--phone');
        //   inputWrap.removeChild(errorSpan);
        // }
        return true;
    }

    function validateEmail(input) {
        const email = input.value;
        const inputWrap = input.parentElement;
        const pattern =
            /^[a-zA-Z0-9._%+-/!#$%&'*=?^_`{|}~]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/; // This is the regex that salesforce accepts

        if (!pattern.test(email) || email === '') {
            if (input.parentElement.querySelector('.input-error--email'))
                return;
            const span = createErrorMsg('email');
            inputWrap.appendChild(span);
            return false;
        }

        if (inputWrap.querySelector('.input-error--email')) {
            const errorSpan = inputWrap.querySelector('.input-error--email');
            inputWrap.removeChild(errorSpan);
        }
        return true;
    }

    function validateText(input) {
        const text = input.value;
        const inputWrap = input.parentElement;
        const pattern =
            /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\-\_ ]+$/;

        if (!pattern.test(text) || text === '') {
            if (input.parentElement.querySelector('.input-error--text')) return;
            const span = createErrorMsg('text');
            inputWrap.appendChild(span);
            return false;
        }

        if (inputWrap.querySelector('.input-error--text')) {
            const errorSpan = inputWrap.querySelector('.input-error--text');
            inputWrap.removeChild(errorSpan);
        }
        return true;
    }

    function validateInput(input) {
        if (input.type === 'email') {
            return validateEmail(input);
        }

        if (input.name === 'phone') {
            return validatePhone(input);
        }

        if (input.type === 'text') {
            return validateText(input);
        }

        return false;
    }

    function checkValid(e) {
        const input = e.target;

        if (input.value != '') {
            input.classList.add('not-empty');
        } else {
            input.classList.remove('not-empty');
        }

        if (input.value != '' && validateInput(input)) {
            input.classList.add('valid');
        } else {
            input.classList.remove('valid');
        }
    }

    init();
});
